<template>
  <a-modal :title="'编辑模板：' + (record ? record.title : '')" :width="600" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="票据标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入标题' }] }]" />
      </a-form-item>
      <a-form-item label="表头显示" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-checkbox-group v-decorator="['header', {}]">
          <a-checkbox value="area">区域</a-checkbox>
          <a-checkbox value="table">桌台</a-checkbox>
          <a-checkbox value="people">人数</a-checkbox>
          <a-checkbox value="orderNo">单号</a-checkbox>
          <a-checkbox value="time">时间</a-checkbox>
          <a-checkbox value="operator">操作员</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="菜品行显示" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-checkbox-group v-decorator="['item', {}]">
          <a-checkbox value="name">名称</a-checkbox>
          <a-checkbox value="quantity">数量</a-checkbox>
          <a-checkbox value="unit">单位</a-checkbox>
          <a-checkbox value="options">做法</a-checkbox>
          <a-checkbox value="remark">备注</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="字号" :labelCol="labelCol" :wrapperCol="wrapperCol">
        标题 <a-select v-decorator="['titleSize', { initialValue: 2 }]" style="width:90px">
          <a-select-option :value="1">标准</a-select-option><a-select-option :value="2">倍大</a-select-option></a-select>
        <span style="margin:0 8px">/</span>
        菜品 <a-select v-decorator="['itemSize', { initialValue: 1 }]" style="width:90px">
          <a-select-option :value="1">标准</a-select-option><a-select-option :value="2">倍大</a-select-option></a-select>
      </a-form-item>
      <a-form-item label="分隔线字符" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['divider', { initialValue: '-' }]" style="width:120px" />
      </a-form-item>
      <a-form-item label="按分类分区" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-switch v-decorator="['groupByCategory', { valuePropName: 'checked', initialValue: false }]" />
        <span style="margin-left:8px;color:#999">开启后菜品按分类分组显示</span>
      </a-form-item>
      <a-form-item label="尾部文字" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea v-decorator="['footer']" :rows="2" placeholder="如：谢谢惠顾 / 关注公众号（留空不打印）" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { printTemplateSave } from '@/api/plugin/dining'

export default {
  name: 'DiningTemplateModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      record: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 17, offset: 1 },
      form: this.$form.createForm(this)
    }
  },
  methods: {
    edit(record) {
      this.record = record
      this.visible = true
      const cfg = record.config || {}
      const header = cfg.header || {}
      const item = cfg.item || {}
      const fontSize = cfg.fontSize || {}
      this.$nextTick(() => this.form.setFieldsValue({
        title: cfg.title || record.title,
        header: Object.keys(header).filter(k => header[k]),
        item: Object.keys(item).filter(k => item[k]),
        titleSize: fontSize.title || 2,
        itemSize: fontSize.item || 1,
        divider: cfg.divider || '-',
        groupByCategory: !!cfg.groupByCategory,
        footer: cfg.footer || ''
      }))
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        const header = {}
        const item = {}
        const fontSize = { title: values.titleSize, item: values.itemSize }
        // 表单勾选 → 开关映射（勾=显示；未勾=false 覆盖默认）
        const headerAll = ['area', 'table', 'people', 'orderNo', 'time', 'operator']
        const itemAll = ['name', 'quantity', 'unit', 'options', 'remark']
        headerAll.forEach(k => { header[k] = (values.header || []).indexOf(k) > -1 })
        itemAll.forEach(k => { item[k] = (values.item || []).indexOf(k) > -1 })
        const config = {
          title: values.title,
          header, item, fontSize,
          divider: values.divider || '-',
          groupByCategory: !!values.groupByCategory,
          footer: values.footer || ''
        }
        this.confirmLoading = true
        printTemplateSave(this.record.billType, config).then(res => {
          this.confirmLoading = false
          if (res.code === 200) {
            this.$message.success(res.message || '保存成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        }).catch(() => { this.confirmLoading = false })
      })
    },
    handleCancel() { this.visible = false }
  }
}
</script>
